import React, { Component } from "react"
import { withRouter } from "react-router-dom"
class TextArea extends Component {
  render() {
    return (
      <div className={this.props.sizeClass}>
        <div className="form-group">
          <label>{this.props.label}</label>
          <div className="form-group label-floating">
            <label className="control-label">{this.props.subTitle}</label>
            <textarea
              disabled={this.props.disabled}
              name={this.props.name}
              onChange={this.props.onChange}
              value={this.props.value}
              className="form-control"
              rows={this.props.rows || "5"}
            />
            <span className="label label-danger">{this.props.error}</span>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(TextArea)



// WEBPACK FOOTER //
// ./src/components/TextArea.js